// @ts-check
import { collection, getDocs, query, where } from "firebase/firestore";

/**
 * Ficha `users` del residente que muestra una pantalla de residente: la propia,
 * o la del residente que el staff mira en "Ver como residente".
 *
 * En "ver como" quien está logueado es staff. Con las reglas 0D (C10) el staff
 * lee fichas ajenas solo por id o con where('accessBids','array-contains', bid):
 * la consulta por email se le negaría entera. Tampoco hace falta: el contexto
 * de "ver como" (EffectiveIdentityProvider en App.js) ya trae el userid y el
 * nombre del residente. Fuera de "ver como" se lee la ficha propia por email,
 * que las reglas dejan leer a cualquier cuenta.
 *
 * @param {import("firebase/firestore").Firestore} db - Instancia de Firestore
 * @param {{ email?: string | null, userid?: string | number | null, viendoComo?: boolean, nombre?: string | null }} identidad
 *   - Lo que da useEffectiveIdentity(): email, userid y readOnly ("ver como"); nombre = viewingAs.name
 * @returns {Promise<{ userid: string | number, docId: string | null, data: Record<string, any> } | null>}
 *   null si no hay email o no existe la ficha
 */
export async function leerFichaResidente(db, { email = null, userid = null, viendoComo = false, nombre = null } = {}) {
  if (viendoComo && userid != null && String(userid).trim() !== "") {
    return { userid, docId: null, data: { userid, name: nombre || "" } };
  }
  if (!email) return null;
  const snap = await getDocs(query(collection(db, "users"), where("email", "==", email)));
  if (snap.empty) return null;
  const d = snap.docs[0];
  const data = d.data() || {};
  return { userid: data.userid || d.id, docId: d.id, data };
}
